import { Box } from '@mui/material';
import React, { useMemo } from 'react';
import { VyDialog } from '../../../../../../components/new-design/feedback/VyDialog';

type RawResponseDialogProps = {
  rawResponse: string;
  open: boolean;
  onClose: () => void;
};

export const RawResponseDialog: React.FC<RawResponseDialogProps> = ({ rawResponse, open, onClose }) => {
  const formattedJson = useMemo(() => formatRawResponse(rawResponse), [rawResponse]);

  return (
    <VyDialog open={open} onClose={onClose} label="Marketplace Raw Response" maxWidth="md" fullWidth>
      <Box
        component="pre"
        sx={{
          whiteSpace: 'pre-wrap',
          wordBreak: 'break-word',
          fontSize: '0.8125rem',
          fontFamily: 'monospace',
          m: 0,
          p: 1,
          bgcolor: '#f5f5f5',
          borderRadius: 1,
          maxHeight: '60vh',
          overflow: 'auto',
        }}
      >
        {formattedJson}
      </Box>
    </VyDialog>
  );
};

function formatRawResponse(rawResponse: string): string {
  try {
    return JSON.stringify(JSON.parse(rawResponse), null, 2);
  } catch {
    return rawResponse;
  }
}
